
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      echart: {} as any,
      myChart: {} as any,
      data: null as any,
      legend: null as any,
      color: null as any,
      name: null as any,
      rate: 0,
      style: {
        width: "0px",
        height: "0px",
        "background-color": "white",
        "border-radius": "100%",
      },
    };
  },
  mounted() {
    this.init();
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    setAndInit(data1: number, data2: number, name: string, type: number) {
      this.data = [
        {
          name: "",
          value: data1,
        },
        {
          name: "",
          value: data2,
        },
      ];
      var typed = this.getTyped(type);
      this.color = [typed.chartColor, typed.chartColor];
      this.style["background-color"] = typed.innerColor;
      this.name = name;
      this.rate = data1 ? Math.round((data2 / data1) * 100) : 0;
      this.setInner();
      const obj = this.getOption();
      this.myChart.setOption(obj);
    },
    init() {
      this.echart = require("echarts");
      this.myChart = this.echart.init(this.$refs.barchart);
    },
    setOption(name: string, total: number, value: number) {
      const opt: any = {};
    },
    getOption() {
      var opt = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
          position: ["50%", "50%"],
          show: false,
        },
        legend: this.legend,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          top: "3%",
          containLabel: true,
        },
        series: [
          {
            hoverAnimation: false,
            type: "pie",
            radius: ["85%", "100%"],
            center: ["50%", "50%"],
            data: this.data,
            color: this.color,
            label: {
              position: "center",
              alignTo: "none",
              bleedMargin: 0,
              formatter: "{d}",
              show: false,
            },
            labelLine: {
              length: 10,
              length2: 10,
            },
          },
        ],
      };
      //   opt.title = this.pietitle;
      return opt;
    },
    setInner() {
      const rateHtml: any = this.$refs.rate;
      var width = rateHtml.clientWidth;
      var height = rateHtml.clientHeight;
      if (width > height) {
        width = height;
      } else {
        height = width;
      }
      this.style.width = this.style.height = `${width * 0.7}px`;
    },
    getTyped(type: number) {
      let ret: any = {};
      switch (type) {
        case 0:
          //正常
          ret.chartColor = "#3197FA";
          ret.innerColor = "#3197FA";
          break;
        case 1:
          //警告
          ret.chartColor = "#FFB744";
          ret.innerColor = "#FFB744";
          break;
        case 2:
          //警告
          ret.chartColor = "#FF4848";
          ret.innerColor = "#FF4848";
          break;
      }
      return ret;
    },
  },
});
